import styled from "styled-components"

export const LogoAmorSaude = styled.img`
  display: block;
  height: auto;
  max-width: 100;
`